import axios from "axios";
export default {
  methods: {
    /*MANEJO DE EXCEPIONES*/
    ManejarExcepcion(e) {
      if (e.response != null && e.response != "undefined") {
        if (e.response.status == 404) {
          this.AlertaEmbajadores("Error 404 | Servicio no encontrado.", false);
        } else if (e.response.status == 403 || e.response.status == 401) {
          this.AlertaEmbajadores("No autorizado para esta operación.", false);
          this.$router.push({ name: "LoginMaster" });
        } else {
          if (e.response.data.estado === 4) {
            //NO LOGEADO
            this.AlertaEmbajadores(e.response.data.mensaje, true);
            this.$router.push({ name: "LoginMaster" });
          } else {
            this.AlertaEmbajadores(e.response.data.mensaje, true);
          }
        }
      } 
    },
    /*ALERTA EMBAJADORES*/
    AlertaEmbajadores(mensaje, bold, ingles) {
      if (bold) {
        this.$fire({
          title: mensaje,
          showCancelButton: false,
          confirmButtonText: ingles ? "Accept" : "Aceptar",          
          cancelButtonText: ingles ? "Cancel" : "Cancelar"
        });
      } else {
        this.$fire({
          text: mensaje,
          showCancelButton: false,
          confirmButtonText: ingles ? "Accept" : "Aceptar",          
          cancelButtonText: ingles ? "Cancel" : "Cancelar"
        });
      }
    },
    /*Establecer primer acceso prospecto*/
    async EstablecerPrimerAccesoProspecto(prospectoId){
      await axios
        .post("/api/Master/Prospecto/EstablecerPrimerAccesoProspecto" + "?prospectoId=" + prospectoId)
        .then(() => {

        }).catch(e => this.ManejarExcepcion(e));
    }
  }
};
